// extracted by mini-css-extract-plugin
export default {"flexContainer":"IqMessengerConnection_flexContainer__brDhf","flexItemRight":"IqMessengerConnection_flexItemRight__yC77l"};